import { render, staticRenderFns } from "./edrpou.vue?vue&type=template&id=568d9172&"
import script from "./edrpou.vue?vue&type=script&lang=js&"
export * from "./edrpou.vue?vue&type=script&lang=js&"
import style0 from "./edrpou.vue?vue&type=style&index=0&id=568d9172&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568d9172')) {
      api.createRecord('568d9172', component.options)
    } else {
      api.reload('568d9172', component.options)
    }
    module.hot.accept("./edrpou.vue?vue&type=template&id=568d9172&", function () {
      api.rerender('568d9172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/bill/advanced/edrpou.vue"
export default component.exports